import React from 'react'
import { Grid } from '@mui/material'

import { useMutatePersonalSettings } from '@/services'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'
import { useMobileSelect } from '@/hooks'

import { defaultSettings, KEY_PAGE, PartialC2BQr } from './default-settings-c2b-page.tsx'
import { CreateQrButton, C2BTypeFilter, CreateStaticQrButton, C2BQrsTable } from './components'

export const C2BQrsPage = (): React.ReactElement => {
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))
  const { isMobile } = useMobileSelect()

  const getSettings = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(defaultSettings)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: defaultSettings[e as keyof PartialC2BQr],
      isChecked: true,
    }))
    Object.keys(defaultSettings).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: defaultSettings[key as keyof PartialC2BQr], isChecked: false })
      }
    })

    return settings
  }

  return (
    <>
      <Grid container flexDirection="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid item xs={10} md={4}>
          <C2BTypeFilter />
        </Grid>
        <Grid
          container
          spacing={2}
          item
          xs={14}
          lg={!isMobile ? 14 : 8}
          px1240={!isMobile ? 8 : undefined}
          justifyContent={{
            xs: 'flex-start',
            px1240: !isMobile ? 'flex-end' : undefined,
            lg: !isMobile ? 'flex-start' : 'flex-end',
          }}
        >
          <Grid item>
            <CreateStaticQrButton />
          </Grid>
          <Grid item>
            <CreateQrButton type="C2B" title="Создать динамический QR" />
          </Grid>
          <Grid item>
            <PersonCustomizationDialog
              personalSettingsKey={KEY_PAGE}
              mutation={useMutatePersonalSettings()}
              itemsDesktop={getSettings('desktop', settings)}
              itemsMobile={getSettings('mobile', settings)}
            />
          </Grid>
        </Grid>
      </Grid>
      <C2BQrsTable />
    </>
  )
}
